/**
 * The widget's own labels. Tenant-written text — title, welcome message, questions — is shown as
 * written; only what the widget itself says lives here.
 */
export const UI_STRINGS = {
  newChat: 'New chat',
  close: 'Close chat',
  conversation: 'Chat conversation',
  suggestedQuestions: 'Suggested questions',
  placeholder: 'Ask a question…',
  send: 'Send message',
  sources: 'Sources',
  copy: 'Copy answer',
  copied: 'Copied',
  helpful: 'Helpful',
  notHelpful: 'Not helpful',
  newMessage: 'New message',
  poweredBy: 'Powered by',
  confirm: 'Confirm',
  approve: 'Approve',
  reject: 'Not now',
  approved: 'Approved',
  rejected: 'Declined',
  expired: 'This request expired.',
  failed: 'Something went wrong.',
  pendingApproval: 'Approve or decline the action above to continue.',
  toolBudget: 'Reached the tool-use limit for this turn.',
  replyError: 'Sorry, something went wrong. Please try again.',
  continueError: 'Couldn’t continue the conversation.',
  // The operator portal's preview simulates a reply with every extra the operator switched on.
  previewReply: 'This is a preview reply.',
  previewSource: 'Help centre',
  previewFollowUps: ['Tell me more', 'Talk to a person'],
} as const;
